import React from 'react';
import { LAYOUT } from '../../styles/constants';
import { useLanguage } from '../../contexts/LanguageContext';

const WelcomeContent = () => {
  const { t } = useLanguage();

  return (
    <div 
      className="bg-[#D9D9D9] p-6"
      style={{ 
        width: LAYOUT.WELCOME.CARD.WIDTH,
        height: LAYOUT.WELCOME.CARD.HEIGHT
      }}
    >
      <h2 className="text-2xl font-bold mb-4">{t('welcome.title')}</h2>
      <p className="text-gray-700 leading-relaxed">
        {t('welcome.description')}
      </p>
      <button className="mt-4 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors">
        {t('welcome.readMore')}
      </button>
    </div>
  );
};

export default WelcomeContent;